import { ApiError } from '../classes/api-error';
import type { FetchWatcher } from '../classes/api';

import type { UnwrapFetchWatcherArray } from './useApiWithErrors';
import { useApiWithErrors } from './useApiWithErrors';

export const useApi = <
  T extends ReadonlyArray<FetchWatcher | undefined | null>,
>(
  ...watchers: T
): UnwrapFetchWatcherArray<T> => {
  const readyData = useApiWithErrors(...watchers);

  readyData.forEach(data => {
    if (data instanceof ApiError) {
      throw data;
    }
  });

  return readyData;
};
